<template>
  <div class="action-paln-form-item">
    <table class="action-paln-form-item__table">
      <tbody>
        <tr class="title">
          <!-- row 1 -->
          <td>#{{ index }} ID {{ riskAnalysis.id }}</td>
          <td>AÇÕES</td>
          <td>IDENTIFICAÇÃO</td>
          <td>STATUS</td>
          <td>DESCRIÇÃO</td>
          <td
            class="table-title clickable"
            @click="showSingleImage(METRIC_IMAGES.hrn)"
          >
            HRN
            <div class="no-print">
              <a @click="toggleHrnView">{{
                showHrnResidualAnalysis ? 'Ver HRN' : 'Ver Análise Residual'
              }}</a>
            </div>
          </td>
        </tr>

        <tr>
          <!-- row 2 -->
          <td rowspan="7">
            <div class="analysis-image">
              <analysis-images-gallery
                v-if="riskAnalysis?.pictures_url?.length > 1"
                :images="riskAnalysis.pictures_url"
                @open-gallery="handleOpenGallery"
              ></analysis-images-gallery>
              <img
                v-else
                class="clickable"
                :src="riskAnalysis.picture_url"
                alt=""
                @click="showSingleImage(riskAnalysis.picture_url)"
              />
            </div>
            <div class="upload-title text-center font-size-1 font-weight-bold">
              Melhorias Objetivas
            </div>
            <div class="btn btn-success w-100 my-2 no-print" @click="showUploadPanel">
              Upload Melhoria Objetiva
            </div>
            <div class="upload-description text-center no-print">
              Upload de Fotos ou Documentos evidenciando o Status atual da
              situação.
            </div>

            <div class="file-list mt-3">
              <div v-if="objectiveImprovementsFiles?.length === 0">
                Essa não conformidade ainda não tem nenhuma melhoria objetiva.
              </div>
              <div v-else>
                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.budget"
                >
                  <div class="file-title">
                    Orçamento
                    <span style="color: orange">{{
                      !objectiveImprovements.budget?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.budget.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.budget?.file"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.budget?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="onObjectiveImprovementFileDelete('budget')"
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.adequacyProject"
                >
                  <div class="file-title">
                    Projeto Adequação
                    <span style="color: orange">{{
                      !objectiveImprovements.adequacyProject?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.adequacyProject.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.adequacyProject?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.adequacyProject?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="
                        onObjectiveImprovementFileDelete('adequacyProject')
                      "
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.projectArt"
                >
                  <div class="file-title">
                    Art do Projeto
                    <span style="color: orange">{{
                      !objectiveImprovements.projectArt?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.projectArt.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.projectArt?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.projectArt?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="onObjectiveImprovementFileDelete('projectArt')"
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.purchaseOrder"
                >
                  <div class="file-title">
                    Ordem de Compra
                    <span style="color: orange">{{
                      !objectiveImprovements.purchaseOrder?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.purchaseOrder.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.purchaseOrder?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.purchaseOrder?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="onObjectiveImprovementFileDelete('purchaseOrder')"
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.finishedAdequacyPicture"
                >
                  <div class="file-title">
                    Foto Adequação Finalizada
                    <span style="color: orange">{{
                      !objectiveImprovements.finishedAdequacyPicture?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{
                      objectiveImprovements.finishedAdequacyPicture.file_name
                    }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="
                        objectiveImprovements?.finishedAdequacyPicture?.file_url
                      "
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.finishedAdequacyPicture?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="
                        onObjectiveImprovementFileDelete(
                          'finishedAdequacyPicture',
                        )
                      "
                      >Excluir</a
                    >
                  </div>
                </div>

                <div
                  class="file-list__item"
                  v-if="objectiveImprovements.homologationReport"
                >
                  <div class="file-title">
                    Laudo de Homologação
                    <span style="color: orange">{{
                      !objectiveImprovements.homologationReport?.file_url
                        ? ' (PENDENTE)'
                        : ''
                    }}</span>
                  </div>
                  <div class="file-name mt-1">
                    {{ objectiveImprovements.homologationReport.file_name }}
                  </div>
                  <div class="file-options mt-1">
                    <a
                      class="file-options clickable mr-3"
                      target="_blank"
                      v-if="objectiveImprovements?.homologationReport?.file_url"
                      @click="
                        showObjectiveImprovementImage(
                          objectiveImprovements?.homologationReport?.file,
                        )
                      "
                      >Ver</a
                    >
                    <a
                      class="file-options clickable"
                      @click="
                        onObjectiveImprovementFileDelete('homologationReport')
                      "
                      >Excluir</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column no-print">
              <button
                @click="showHistory(riskAnalysis.id)"
                class="btn btn-primary btn-sm mt-3"
              >
                Log de alterações
              </button>
              <router-link
                :to="{
                  name: 'action-plan-print-detailing',
                  params: { riskAnalysisDescriptionId: riskAnalysis.id },
                }"
                class="btn btn-primary btn-sm mt-3"
                style="color: white"
              >
                <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                PDF Detalhamento
              </router-link>
            </div>
          </td>
          <td rowspan="5">
            <div class="row">
              <div class="col-10">
                <div class="form-group">
                  <label>Responsável Empresa / Frente</label>
                  <div class="d-flex">
                    <AutoComplete
                      v-model="data.companyResponsible"
                      :dropdown="true"
                      field="name"
                      :suggestions="filtered_work_fronts"
                      :disabled="data.workFrontId"
                      class="w-100 mr-2"
                      @item-select="onWorkFrontSelect($event)"
                      @complete="filterWorkFronts($event)"
                    />
                    <button class="btn p-1 no-print" @click="unselectWorkFront">
                      <font-awesome-icon
                        :icon="['fas', 'times']"
                      ></font-awesome-icon>
                    </button>
                  </div>
                </div>

                <div class="form-group">
                  <label>Responsável Terceiro</label>
                  <input
                    v-model="data.thirdPartyResponsible"
                    type="text"
                    class="form-control"
                    :disabled="data.workFrontId"
                  />
                </div>

                <div class="form-group">
                  <label>Supervisor Adequação</label>
                  <input
                    v-model="data.adequacySupervisor"
                    type="text"
                    class="form-control"
                    :disabled="data.workFrontId"
                  />
                </div>
              </div>
              <div
                class="
                  col-2
                  d-flex
                  align-items-center
                  justify-content-center
                  no-print
                "
              >
                <button
                  class="btn p-1"
                  v-tooltip="'Copiar campo para outras não conformidades'"
                  @click="copyFields"
                >
                  <font-awesome-icon
                    :icon="['fas', 'copy']"
                  ></font-awesome-icon>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <div class="form-group">
                  <label>Data Programada</label>
                  <Calendar
                    v-model="data.scheduledDate"
                    date-format="dd/mm/yy"
                    selection-mode="single"
                    :month-navigator="true"
                    :year-navigator="true"
                    year-range="2000:2100"
                    class="calendar-custom primevue-custom-field"
                  />
                </div>
              </div>
              <div
                class="
                  col-2
                  d-flex
                  align-items-center
                  justify-content-center
                  no-print
                "
              >
                <button
                  class="btn p-1"
                  v-tooltip="'Copiar campo para outras não conformidades'"
                  @click="copyFieldsDate"
                >
                  <font-awesome-icon
                    :icon="['fas', 'copy']"
                  ></font-awesome-icon>
                </button>
              </div>
            </div>

            <div class="form-group">
              <label>Média Orçamento</label>
              <InputNumber
                v-model="data.averageBudget"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                class="currency-custom primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Data Realizada</label>
              <Calendar
                v-model="data.realizationDate"
                date-format="dd/mm/yy"
                selection-mode="single"
                :month-navigator="true"
                :year-navigator="true"
                year-range="2000:2100"
                class="calendar-custom primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Custo Real</label>
              <InputNumber
                v-model="data.realCost"
                mode="currency"
                currency="BRL"
                locale="pt-BR"
                class="currency-custom primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Observação</label>
              <textarea
                v-model="data.observations"
                type="text"
                class="form-control"
                rows="3"
                style="height: auto"
              ></textarea>
            </div>
          </td>
          <td rowspan="5">
            <div class="form-group">
              <label>Tipo Equipamento</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.machine_type?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Tag Equipamento</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.machine_tag || ''"
              />
            </div>

            <div class="form-group">
              <label>Equip. Primário</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.primary_machine_tag || ''"
              />
            </div>

            <div class="form-group">
              <label>Tag Ambra</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.ambra_tag || ''"
              />
            </div>

            <div class="form-group">
              <label>Setor</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.company_sector?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Área</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.company_area?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Complemento</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.company_complement?.name || ''"
              />
            </div>

            <div class="form-group">
              <label>Capacidade</label>
              <input
                type="text"
                class="form-control"
                readonly="true"
                disabled="disabled"
                :value="machine?.capacity || ''"
              />
            </div>
          </td>
          <td rowspan="5">
            <vertical-stepper
              :steps="steps"
              :alerts="stepsWithProblems || []"
              :current-step="currentStep"
            ></vertical-stepper>
          </td>
          <td>
            <!-- Descrição (Noncompliance) -->
            <span>{{ riskAnalysis?.noncompliance || '' }}</span>
          </td>
          <td class="p-0">
            <table
              class="table-hrn w-100"
              style="height: 100%"
              v-if="!showHrnResidualAnalysis"
            >
              <tbody>
                <tr>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_po)"
                  >
                    PO
                  </td>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_gpd)"
                  >
                    GPD
                  </td>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_fe)"
                  >
                    FE
                  </td>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_np)"
                  >
                    NP
                  </td>
                  <td>RES</td>
                </tr>
                <tr>
                  <td>{{ riskAnalysis.po || '-' }}</td>
                  <td>{{ riskAnalysis.gpd || '-' }}</td>
                  <td>{{ riskAnalysis.fe || '-' }}</td>
                  <td>{{ riskAnalysis.np || '-' }}</td>
                  <td
                    :class="{ unacceptable: riskAnalysis.hrn_level === 8 }"
                    :style="`background-color: ${getHrnLevelColor(
                      riskAnalysis.hrn_level,
                    )}`"
                    width="60px"
                  >
                    {{ riskAnalysis.hrn_result || '-' }}
                  </td>
                </tr>

                <tr
                  class="table-title clickable"
                  @click="showSingleImage(METRIC_IMAGES.iso12100)"
                >
                  <td colspan="6">ISO 12100</td>
                </tr>
                <tr>
                  <td
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Sev.
                  </td>
                  <td
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Freq.
                  </td>
                  <td
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Poss.
                  </td>
                  <td
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Pre.
                  </td>
                  <td>RES.</td>
                </tr>
                <tr>
                  <td>{{ riskAnalysis.iso_12100_severity || '-' }}</td>
                  <td>{{ riskAnalysis.iso_12100_exposure || '-' }}</td>
                  <td>{{ riskAnalysis.iso_12100_probability || '-' }}</td>
                  <td>{{ riskAnalysis.iso_12100_prevention || '-' }}</td>
                  <td
                    :style="{
                      backgroundColor: getIso12100LevelColor(
                        riskAnalysis.iso_12100_level,
                      ),
                    }"
                  >
                    {{ riskAnalysis.iso_12100_result || '-' }}
                  </td>
                </tr>

                <tr
                  class="table-title clickable"
                  @click="showSingleImage(METRIC_IMAGES.iso138491)"
                >
                  <td colspan="6">ISO 13849-1</td>
                </tr>
                <tr class="table-header">
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso138491_quesitos)"
                  >
                    Sev.
                  </td>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso138491_quesitos)"
                  >
                    Exp.
                  </td>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso138491_quesitos)"
                  >
                    Prob.
                  </td>
                  <td
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso138491a)"
                  >
                    Nível Perf.
                  </td>
                  <td>Cat 14153</td>
                </tr>
                <tr>
                  <td>{{ riskAnalysis.iso_138491_severity || '-' }}</td>
                  <td>{{ riskAnalysis.iso_138491_frequency || '-' }}</td>
                  <td>{{ riskAnalysis.iso_138491_prevention || '-' }}</td>
                  <td>{{ riskAnalysis.iso_138491_result || '-' }}</td>
                  <td>{{ riskAnalysis.cat_14153_result || '-' }}</td>
                </tr>
              </tbody>
            </table>

            <table
              class="table-hrn w-100"
              style="height: 100%"
              v-if="showHrnResidualAnalysis"
            >
              <tr>
                <td class="clickable">PO</td>
                <td class="clickable">GPD</td>
                <td class="clickable">FE</td>
                <td class="clickable">NP</td>
                <td>RES</td>
              </tr>
              <tr>
                <td>{{ riskAnalysis.po_residual || '-' }}</td>
                <!--                <td>{{ riskAnalysis.gpd_residual || '-' }}</td>-->
                <!--                <td>{{ riskAnalysis.fe_residual || '-' }}</td>-->
                <!--                <td>{{ riskAnalysis.np_residual || '-' }}</td>-->
                <!--                <td>{{ riskAnalysis.po || '-' }}</td>-->
                <td>{{ riskAnalysis.gpd || '-' }}</td>
                <td>{{ riskAnalysis.fe || '-' }}</td>
                <td>{{ riskAnalysis.np || '-' }}</td>
                <td
                  :class="{ unacceptable: riskAnalysis.hrn_level === 8 }"
                  :style="`background-color: ${getHrnLevelColor(
                    Math.floor(
                      parseFloat(riskAnalysis.gpd) *
                        parseFloat(riskAnalysis.fe) *
                        parseFloat(riskAnalysis.np) *
                        parseFloat(riskAnalysis.po_residual),
                    ),
                  )}`"
                  width="60px"
                >
                  {{
                    parseFloat(riskAnalysis.gpd) *
                      parseFloat(riskAnalysis.fe) *
                      parseFloat(riskAnalysis.np) *
                      parseFloat(riskAnalysis.po_residual) || '-'
                  }}
                  <!--                  {{ riskAnalysis.hrn_residual || '-' }}-->
                </td>
              </tr>

              <tr class="table-title">
                <td colspan="6">ANÁLISE DE RISCO RESIDUAL SUGERIDA</td>
              </tr>

              <tr>
                <td colspan="6" style="text-align: center">
                  A análise de Risco Residual deve ser realizada no momento do
                  laudo de homologação da máquina. Consultar laudo em anexo.
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr class="title">
          <!-- row 3 -->
          <td>AÇÃO</td>
          <td>OBSERVAÇÃO</td>
        </tr>

        <tr>
          <!-- row 4 -->
          <td rowspan="3">
            <span>{{
              riskAnalysis?.noncompliance_model?.treatise
                ?.substring(0, 500)
                .trim() || '-'
            }}</span>
          </td>
          <td>
            <span>{{
              riskAnalysis?.additional_observations?.substring(0, 400).trim() ||
              '-'
            }}</span>
          </td>
        </tr>

        <tr class="title">
          <!-- row 5 -->
          <td>PENALIDADE MÁX. PREVISTA R$</td>
        </tr>

        <tr class="title">
          <!-- row 6 -->
          <td>
            <span>R$ {{ riskAnalysis?.max_fine_value }}</span>
          </td>
        </tr>

        <tr class="title">
          <!-- row 7 -->
          <td colspan="5">Detalhamento da Adequação</td>
        </tr>

        <tr class="details">
          <td>
            <div class="form-group">
              <label>Altura (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.height"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Comprimento (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.length"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Profundidade (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.depth"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Circunferência (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.circunference"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>
          </td>

          <td>
            <div class="form-group">
              <label>Metragem Linear (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.linearMeasurement"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Quantidade de Patamares</label>
              <InputNumber
                v-model="adequacyDetailed.levels"
                mode="decimal"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Largura da Escada (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.stairLength"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>

            <div class="form-group">
              <label>Média Espaçamento Entre Degraus Escada (mm)</label>
              <InputNumber
                v-model="adequacyDetailed.averageStairStepsSpacing"
                mode="decimal"
                :min-fraction-digits="2"
                :max-fraction-digits="2"
                :use-grouping="false"
                class="primevue-custom-field"
              />
            </div>
          </td>

          <td>
            <div class="form-group">
              <label>Obs Técnico Coleta</label>
              <input
                v-model="adequacyDetailed.action_plan_observations"
                type="text"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Breve Descrição do Serviço</label>
              <textarea
                v-model="adequacyDetailed.briefDescription"
                type="text"
                class="form-control"
                rows="3"
                style="height: auto"
              ></textarea>
            </div>
          </td>

          <td colspan="2">
            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="adequacyDetailed.signaling"
                  class="form-check-input"
                  type="checkbox"
                  :id="`adequacy-signaling-${riskAnalysis.id}`"
                />
                <label
                  class="form-check-label"
                  :for="`adequacy-signaling-${riskAnalysis.id}`"
                >
                  Sinalização

                  <span v-if="adequacyDetailed.signaling">
                    -
                    <router-link
                      target="_blank"
                      class="no-print"
                      :to="{
                        name: 'action-plan-signaling-form',
                        params: { riskAnalysisDescriptionId: riskAnalysis.id },
                      }"
                      >Editar</router-link
                    >
                  </span>
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="adequacyDetailed.boilermakingAndLocksmiths"
                  class="form-check-input"
                  type="checkbox"
                  :id="`adequacy-boilermaking-${riskAnalysis.id}`"
                />
                <label
                  class="form-check-label"
                  :for="`adequacy-boilermaking-${riskAnalysis.id}`"
                >
                  Caldeiraria/Serralheria

                  <span v-if="adequacyDetailed.boilermakingAndLocksmiths">
                    -
                    <router-link
                      target="_blank"
                      class="no-print"
                      :to="{
                        name: 'action-plan-boilermaking-form',
                        params: { riskAnalysisDescriptionId: riskAnalysis.id },
                      }"
                      >Editar</router-link
                    >
                  </span>
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="adequacyDetailed.constructionAndLayout"
                  class="form-check-input"
                  type="checkbox"
                  :id="`adequacy-construction-${riskAnalysis.id}`"
                />
                <label
                  class="form-check-label"
                  :for="`adequacy-construction-${riskAnalysis.id}`"
                >
                  Construção Civil/Layout

                  <span v-if="adequacyDetailed.constructionAndLayout">
                    -
                    <router-link
                      target="_blank"
                      class="no-print"
                      :to="{
                        name: 'action-plan-construction-form',
                        params: { riskAnalysisDescriptionId: riskAnalysis.id },
                      }"
                      >Editar</router-link
                    >
                  </span>
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="adequacyDetailed.securityDevices"
                  class="form-check-input"
                  type="checkbox"
                  :id="`adequacy-security-${riskAnalysis.id}`"
                />
                <label
                  class="form-check-label"
                  :for="`adequacy-security-${riskAnalysis.id}`"
                >
                  Dispositivos de Segurança

                  <span v-if="adequacyDetailed.securityDevices">
                    -
                    <router-link
                      target="_blank"
                      class="no-print"
                      :to="{
                        name: 'action-plan-security-devices-form',
                        params: { riskAnalysisDescriptionId: riskAnalysis.id },
                      }"
                      >Editar</router-link
                    >
                  </span>
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="adequacyDetailed.electric"
                  class="form-check-input"
                  type="checkbox"
                  :id="`adequacy-electric-${riskAnalysis.id}`"
                />
                <label
                  class="form-check-label"
                  :for="`adequacy-electric-${riskAnalysis.id}`"
                >
                  Elétrica

                  <span v-if="adequacyDetailed.electric">
                    -
                    <router-link
                      target="_blank"
                      class="no-print"
                      :to="{
                        name: 'action-plan-electric-form',
                        params: { riskAnalysisDescriptionId: riskAnalysis.id },
                      }"
                      >Editar</router-link
                    >
                  </span>
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input
                  v-model="adequacyDetailed.painting"
                  class="form-check-input"
                  type="checkbox"
                  :id="`adequacy-painting-${riskAnalysis.id}`"
                />
                <label
                  class="form-check-label"
                  :for="`adequacy-painting-${riskAnalysis.id}`"
                >
                  Pintura

                  <span v-if="adequacyDetailed.painting">
                    -
                    <router-link
                      target="_blank"
                      class="no-print"
                      :to="{
                        name: 'action-plan-painting-form',
                        params: { riskAnalysisDescriptionId: riskAnalysis.id },
                      }"
                      >Editar</router-link
                    >
                  </span>
                </label>
              </div>
            </div>

            <router-link
              target="_blank"
              class="no-print"
              :to="{
                name: 'action-plan-difficulties-form',
                params: { riskAnalysisDescriptionId: riskAnalysis.id },
              }"
              >Dificuldades de Implementação</router-link
            >

            <button
              @click="save()"
              class="btn btn-success float-right no-print"
            >
              Salvar
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="objective-improvements-inputs d-none">
      <input
        type="file"
        ref="budgetFile"
        @change="onObjectiveImprovementFileInput($event, 'budget')"
      />

      <input
        type="file"
        ref="adequacyProjectFile"
        @change="onObjectiveImprovementFileInput($event, 'adequacyProject')"
      />

      <input
        type="file"
        ref="projectArtFile"
        @change="onObjectiveImprovementFileInput($event, 'projectArt')"
      />

      <input
        type="file"
        ref="purchaseOrderFile"
        @change="onObjectiveImprovementFileInput($event, 'purchaseOrder')"
      />

      <input
        type="file"
        ref="finishedAdequacyPictureFile"
        @change="
          onObjectiveImprovementFileInput($event, 'finishedAdequacyPicture')
        "
      />

      <input
        type="file"
        ref="homologationReportFile"
        @change="onObjectiveImprovementFileInput($event, 'homologationReport')"
      />
    </div>

    <OverlayPanel
      :show-close-icon="true"
      :dismissable="true"
      ref="overlayPanel"
    >
      <div class="objective-improvements-upload-options">
        <div class="option-row option-row-1">
          <div class="option clickable" @click="$refs.budgetFile.click()">
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-1.png" alt="" />
            </div>
            <div class="option__title">Orçamento Cotação</div>
          </div>

          <div
            class="option clickable"
            @click="$refs.adequacyProjectFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-2.png" alt="" />
            </div>
            <div class="option__title">Projeto Adequação</div>
          </div>

          <div class="option clickable" @click="$refs.projectArtFile.click()">
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-3.png" alt="" />
            </div>
            <div class="option__title">Art do Projeto</div>
          </div>
        </div>
        <div class="option-row option-row-2">
          <div
            class="option clickable"
            @click="$refs.purchaseOrderFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-4.png" alt="" />
            </div>
            <div class="option__title">Ordem de Compra</div>
          </div>

          <div
            class="option clickable"
            @click="$refs.finishedAdequacyPictureFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-5.png" alt="" />
            </div>
            <div class="option__title">Foto Adequação Finalizada</div>
          </div>

          <div
            class="option clickable"
            @click="$refs.homologationReportFile.click()"
          >
            <div class="option__image">
              <img src="@/assets/images/melhoria-objetiva-6.png" alt="" />
            </div>
            <div class="option__title">Laudo de Homologação</div>
          </div>
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
  import OverlayPanel from 'primevue/overlaypanel'
  import Calendar from 'primevue/calendar'
  import InputNumber from 'primevue/inputnumber'
  import AutoComplete from 'primevue/autocomplete'

  import VerticalStepper from './VerticalStepper'

  import useHrn from '@/modules/Hrn.js'
  import useIso12100 from '@/modules/Iso12100.js'
  import useImageViewer from '@/modules/ImageViewer.js'
  import useSwal from '@/modules/Swal.js'

  import { METRIC_IMAGES } from '@/constants/images.constants.js'
  import * as ActionPlanServiceTypesEnum from '@/constants/action-plan-service.constants.js'
  import * as ObjectiveImprovementTypesEnum from '@/constants/objective-improvement-type.constants.js'

  import AnalysisImagesGallery from '@/components/preliminary_risk_analyses/components/AnalysisImagesGallery'

  export default {
    setup() {
      const { getHrnLevelColor } = useHrn()
      const { getIso12100LevelColor } = useIso12100()

      const { showImageIndex, showSingleImage } = useImageViewer()

      const { showConfirmationDialog } = useSwal()
      const { showConfirmDeletionSwal } = useSwal()
      const { showSuccessDialog } = useSwal()

      return {
        METRIC_IMAGES,

        getHrnLevelColor,
        getIso12100LevelColor,

        showSingleImage,
        showImageIndex,
        showConfirmationDialog,
        showConfirmDeletionSwal,
        showSuccessDialog,
        AnalysisImagesGallery,
      }
    },
    components: {
      OverlayPanel,
      Calendar,
      InputNumber,
      VerticalStepper,
      AutoComplete,
    },
    props: {
      riskAnalysis: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
      filters: {
        type: String,
        default: '',
        required: false,
      },
      workFronts: {
        type: Object,
        required: false,
      },
    },
    data() {
      return {
        currentStep: 0,
        showHrnResidualAnalysis: false,
        stepsWithProblems: [],
        steps: [
          'DELEGADO',
          'PROGRAMADO',
          'ORÇADO',
          'PROJETADO',
          'EM ADEQUAÇÃO',
          'CONCLUÍDO',
          'HOMOLOGADO',
        ],
        data: {
          workFrontId: null,
          companyResponsible: '',
          thirdPartyResponsible: '',
          adequacySupervisor: '',

          scheduledDate: '',

          ecommercePriceEnabled: false,

          averageBudget: null,
          realizationDate: '',
          realCost: null,
          observations: '',
        },
        adequacyDetailed: {
          height: null,
          length: null,
          depth: null,
          circunference: null,
          linearMeasurement: null,
          levels: null,
          stairLength: null,
          averageStairStepsSpacing: null,

          technicianObservation: '',
          briefDescription: '',
          action_plan_observations: '',

          signaling: false,
          boilermakingAndLocksmiths: false,
          constructionAndLayout: false,
          securityDevices: false,
          electric: false,
          painting: false,
        },
        machine: {
          machine_type: { name: '' },
          machine_tag: '',
          primary_machine_tag: '',
          ambra_tag: '',
          copany_sector: { name: '' },
          copany_area: { name: '' },
          copany_complement: { name: '' },
          capacity: '',
        },
        objectiveImprovements: {
          budget: null,
          adequacyProject: null,
          projectArt: null,
          purchaseOrder: null,
          finishedAdequacyPicture: null,
          homologationReport: null,
        },
        filtered_work_fronts: [],
      }
    },
    emits: ['copy-all'],
    methods: {
      showHistory(id) {
        window.open(
          process.env.VUE_APP_API_URL + '/api/action-plan/history/' + id,
          'pagina',
          'width=850, height=355, top=100, left=110, scrollbars=no ',
        )
      },
      toggleHrnView(event) {
        event.stopPropagation()

        this.showHrnResidualAnalysis = !this.showHrnResidualAnalysis
      },
      showUploadPanel(event) {
        this.$refs.overlayPanel.toggle(event)
      },
      save() {
        let formData = new FormData()
        formData.append('signaling', this.adequacyDetailed.signaling)
        formData.append('security', this.adequacyDetailed.securityDevices)
        formData.append('painting', this.adequacyDetailed.painting)
        formData.append('electric', this.adequacyDetailed.electric)
        formData.append(
          'construction',
          this.adequacyDetailed.constructionAndLayout,
        )
        formData.append(
          'boilermaking',
          this.adequacyDetailed.boilermakingAndLocksmiths,
        )

        formData.append('risk_analysis_description_id', this.riskAnalysis.id)
        formData.append('budget', this.objectiveImprovements.budget)
        formData.append(
          'adequacyProject',
          this.objectiveImprovements.adequacyProject,
        )
        formData.append('projectArt', this.objectiveImprovements.projectArt)
        formData.append(
          'purchaseOrder',
          this.objectiveImprovements.purchaseOrder,
        )
        formData.append(
          'finishedAdequacyPicture',
          this.objectiveImprovements.finishedAdequacyPicture,
        )
        formData.append(
          'homologationReport',
          this.objectiveImprovements.homologationReport,
        )

        let putData = {
          riskAnalysis: this.riskAnalysis,
          ...this.data,
          ...this.adequacyDetailed,
          ...this.machine,
          ...this.objectiveImprovements,
        }
        this.axios
          .put('/api/action-plan/update', putData)
          .then(() => {})
          .catch((e) => console.log(e))

        this.axios
          .post('/api/action-plan/update/files', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(({ data }) => {
            if (data[0].type === 5) {
              this.objectiveImprovements.finishedAdequacyPicture = data[0]
            }
            this.showSuccessDialog()
          })
          .catch((e) => console.log(e))
      },
      async showObjectiveImprovementImage(file) {
        let image = ''
        let fileName = ''

        await this.axios
          .get(`/api/action-plan/getObjectImprovementImage?file=${file}`)
          .then((data) => {
            image = data.data.b64
            fileName = data.data.fileName
          })
          .catch((e) => console.log(e))

        image = 'data:image/jpg;base64,' + image
        if (file.endsWith('.pdf')) {
          const downloadLink = document.createElement('a')
          downloadLink.href = image
          downloadLink.download = fileName
          downloadLink.click()
        } else {
          this.showSingleImage(image)
        }
      },
      onObjectiveImprovementFileInput(event, type) {
        const app = this

        const file = event.target.files[0]

        const map = {
          budget: () => {
            app.objectiveImprovements.budget = file
          },
          adequacyProject: () => {
            app.objectiveImprovements.adequacyProject = file
          },
          projectArt: () => {
            app.objectiveImprovements.projectArt = file
          },
          purchaseOrder: () => {
            app.objectiveImprovements.purchaseOrder = file
          },
          finishedAdequacyPicture: () => {
            app.objectiveImprovements.finishedAdequacyPicture = file
          },
          homologationReport: () => {
            app.objectiveImprovements.homologationReport = file
          },
        }

        if (Object.keys(map).includes(type)) map[type]()

        this.objectiveImprovement = { ...this.objectiveImprovement }
      },
      onObjectiveImprovementFileDelete(type) {
        const app = this

        const map = {
          budget: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.budget.id,
                  )
                  .then(() => (app.objectiveImprovements.budget = null))
              }
            })
          },
          adequacyProject: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.adequacyProject.id,
                  )
                  .then(
                    () => (app.objectiveImprovements.adequacyProject = null),
                  )
              }
            })
          },
          projectArt: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.projectArt.id,
                  )
                  .then(() => (app.objectiveImprovements.projectArt = null))
              }
            })
          },
          purchaseOrder: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.purchaseOrder.id,
                  )
                  .then(() => (app.objectiveImprovements.purchaseOrder = null))
              }
            })
          },
          finishedAdequacyPicture: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.finishedAdequacyPicture.id,
                  )
                  .then(
                    () =>
                      (app.objectiveImprovements.finishedAdequacyPicture =
                        null),
                  )
              }
            })
          },
          homologationReport: () => {
            this.showConfirmDeletionSwal().then((response) => {
              if (response.isConfirmed) {
                this.axios
                  .delete(
                    '/api/action-plan/remove/file/' +
                      app.objectiveImprovements.homologationReport.id,
                  )
                  .then(
                    () => (app.objectiveImprovements.homologationReport = null),
                  )
              }
            })
          },
        }

        if (Object.keys(map).includes(type)) map[type]()

        this.objectiveImprovement = { ...this.objectiveImprovement }
      },
      setStep() {
        const app = this
        const lastStep = 7
        let stepsDone = []
        let stepsWithProblems = []

        //Each key is a step
        //Each value is a boolean; if true, the step is valid
        const validator = {
          1: (() => {
            return !!app.data.companyResponsible
          })(),

          2: (() => {
            return !!app.data.scheduledDate
          })(),

          3: (() => {
            return !!app.data.averageBudget
          })(),

          4: (() => {
            return !!app.objectiveImprovements.adequacyProject
          })(),

          5: (() => {
            return !!app.objectiveImprovements.projectArt
          })(),

          6: (() => {
            return !!app.objectiveImprovements.finishedAdequacyPicture
          })(),

          7: (() => {
            return !!app.objectiveImprovements.homologationReport
          })(),
        }

        //Loop through the validator;
        //If the step is valid, it's added to the stepsDone array
        //Add it to the stepsWithProblems array otherwise
        for (let step = 1; step <= lastStep; step++) {
          if (validator[step]) stepsDone.push(step)
          else stepsWithProblems.push(step)
        }

        //The current step is the last done step;
        const lastStepDone =
          stepsDone.length > 0 ? stepsDone[stepsDone.length - 1] : -1

        //To decide if a step has a problem, it has to be lower than the last done step.
        //Otherwise, steps that have not yet been filled, would be considered problematic, what is not true
        stepsWithProblems = stepsWithProblems.filter((p) => p < lastStepDone)

        this.currentStep = lastStepDone
        this.stepsWithProblems = [...stepsWithProblems]
      },
      copyFields() {
        this.showConfirmationDialog(
          'Certeza que deseja copiar este campo?',
          'Este campo será aplicado a todos os outros que sigam o preenchiento dos filtros',
          'warning',
        ).then((response) => {
          if (response) {
            this.axios.put(
              '/api/action-plan/update-all',
              this.filters + '&responsible=' + this.data.thirdPartyResponsible,
            )
          }
        })
      },
      copyFieldsDate() {
        this.showConfirmationDialog(
          'Certeza que deseja copiar este campo?',
          'Este campo será aplicado a todos os outros que sigam o preenchiento dos filtros',
          'warning',
        ).then((response) => {
          if (response) {
            let dater = new Date(Date.parse(this.data.scheduledDate))
            let dataFormatada =
              dater.getFullYear() +
              '-' +
              (dater.getMonth() + 1) +
              '-' +
              dater.getDate()

            console.log(dataFormatada)
            this.axios.put(
              '/api/action-plan/update-all-date',
              this.filters + '&scheduled_date=' + dataFormatada,
            )
          }
        })
      },
      mapDataToState() {
        this.fillBaseData()
        this.fillAdequacy()
        this.fillObjectiveImprovements()
      },
      fillBaseData() {
        let realizationDate, scheduledDate

        if (this.riskAnalysis.realization_date)
          realizationDate = new Date(this.riskAnalysis.realization_date)

        if (this.riskAnalysis.scheduled_date)
          scheduledDate = new Date(this.riskAnalysis.scheduled_date)

        this.data = {
          ...this.data,
          realizationDate,
          scheduledDate,
          companyResponsible: this.riskAnalysis.company_responsible,
          thirdPartyResponsible: this.riskAnalysis.third_party_responsible,
          adequacySupervisor: this.riskAnalysis.adequacy_supervisor,
          averageBudget: this.riskAnalysis.average_budget,

          realCost: this.riskAnalysis.real_cost,
          observations: this.riskAnalysis.observations,
        }

        if (this.riskAnalysis.work_front_id) {
          this.data.workFrontId = this.riskAnalysis.work_front_id
          this.data.companyResponsible = this.riskAnalysis.work_front.name
          this.data.thirdPartyResponsible = this.riskAnalysis.work_front
            .responsible_third_party
            ? this.riskAnalysis.work_front.responsible_third_party.name
            : null
          this.data.adequacySupervisor =
            this.riskAnalysis.work_front.adequacy_supervisor.name
        }
      },
      fillAdequacy() {
        let signaling,
          boilermakingAndLocksmiths,
          constructionAndLayout,
          securityDevices,
          electric,
          painting

        this.riskAnalysis?.action_plan_services?.forEach((actionPlanItem) => {
          if (actionPlanItem.type === ActionPlanServiceTypesEnum.SIGNALING)
            signaling = true
          else if (
            actionPlanItem.type ===
            ActionPlanServiceTypesEnum.BOILERMAKING_LOCKSMITHING
          )
            boilermakingAndLocksmiths = true
          else if (
            actionPlanItem.type ===
            ActionPlanServiceTypesEnum.CONSTRUCTION_LAYOUT
          )
            constructionAndLayout = true
          else if (
            actionPlanItem.type === ActionPlanServiceTypesEnum.SECURITY_DEVICES
          )
            securityDevices = true
          else if (actionPlanItem.type === ActionPlanServiceTypesEnum.ELECTRIC)
            electric = true
          else if (actionPlanItem.type === ActionPlanServiceTypesEnum.PAINTING)
            painting = true
        })

        this.adequacyDetailed = {
          ...this.adequacyDetailed,
          height: this.riskAnalysis.height,
          length: this.riskAnalysis.length,
          depth: this.riskAnalysis.depth,
          circunference: this.riskAnalysis.circunference,
          linearMeasurement: this.riskAnalysis.linear_measurement,
          levels: this.riskAnalysis.levels,
          stairLength: this.riskAnalysis.stair_length,
          averageStairStepsSpacing:
            this.riskAnalysis?.average_stair_steps_spacing,
          technicianObservation: this.riskAnalysis.observations,
          action_plan_observations: this.riskAnalysis.action_plan_observations,
          briefDescription:
            this.riskAnalysis.action_plan_service_brief_description,
          signaling,
          boilermakingAndLocksmiths,
          constructionAndLayout,
          securityDevices,
          electric,
          painting,
        }
      },
      fillObjectiveImprovements() {
        const adequacies = this.riskAnalysis?.objective_improvements

        if (!adequacies) return

        let budget,
          adequacyProject,
          projectArt,
          purchaseOrder,
          finishedAdequacyPicture,
          homologationReport

        adequacies.forEach((adequacyItem) => {
          if (adequacyItem.type === ObjectiveImprovementTypesEnum.BUDGET) {
            budget = adequacyItem
          } else if (
            adequacyItem.type === ObjectiveImprovementTypesEnum.PROJECT_ADEQUACY
          ) {
            adequacyProject = adequacyItem
          } else if (
            adequacyItem.type === ObjectiveImprovementTypesEnum.PROJECT_ART
          ) {
            projectArt = adequacyItem
          } else if (
            adequacyItem.type === ObjectiveImprovementTypesEnum.PURCHASE_ORDER
          ) {
            purchaseOrder = adequacyItem
          } else if (
            adequacyItem.type ===
            ObjectiveImprovementTypesEnum.FINALIZED_ADEQUACY_PICTURE
          ) {
            finishedAdequacyPicture = adequacyItem
            this.showHrnResidualAnalysis = true
          } else if (
            adequacyItem.type ===
            ObjectiveImprovementTypesEnum.HOMOLOGATION_REPORT
          ) {
            homologationReport = adequacyItem
          }
        })

        this.objectiveImprovements = {
          budget,
          adequacyProject,
          projectArt,
          purchaseOrder,
          finishedAdequacyPicture,
          homologationReport,
        }
      },
      handleOpenGallery(event) {
        const { images, index } = event

        this.showImageIndex(images, index)
      },
      unselectWorkFront(event) {
        event.preventDefault()

        this.data.workFrontId = null
        this.data.companyResponsible = ''
        this.data.thirdPartyResponsible = ''
        this.data.adequacySupervisor = ''
      },
      onWorkFrontSelect(event) {
        const work_front = event.value

        this.data.workFrontId = work_front.id
        this.data.companyResponsible = work_front.name
        this.data.thirdPartyResponsible =
          work_front.responsible_third_party.name
        this.data.adequacySupervisor = work_front.adequacy_supervisor.name
      },
      filterWorkFronts(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_work_fronts = [...this.workFronts]
          } else {
            this.filtered_work_fronts = this.workFronts.filter((work_front) =>
              work_front.name
                .toLowerCase()
                .startsWith(event.query.toLowerCase()),
            )
          }
        }, 250)
      },
    },
    computed: {
      objectiveImprovementsFiles() {
        let files = []

        for (let f in this.objectiveImprovements) {
          if (this.objectiveImprovements[f])
            files.push(this.objectiveImprovements[f])
        }
        return files
      },
    },
    watch: {
      data: {
        handler() {
          this.setStep()
        },
        deep: true,
      },
      objectiveImprovements: {
        handler() {
          this.setStep()
        },
        deep: true,
      },
      riskAnalysis() {
        this.machine = { ...(this?.riskAnalysis?.machine || {}) }

        this.mapDataToState()
      },
    },
    mounted() {
      this.machine = { ...(this?.riskAnalysis?.machine || {}) }

      this.mapDataToState()
    },
  }
</script>

<style lang="scss" scoped>
  .action-paln-form-item {
    &__table,
    .table-hrn,
    table {
      width: 100%;

      border-collapse: collapse;
      border-spacing: 0;

      .form-group {
        margin-bottom: 10px;
        display: block;

        label {
          display: block;
          margin: 0;
        }

        .form-control {
          height: 30px;

          font-size: 0.75rem;
        }
      }

      tr {
        td {
          width: 16.66666666666667%;
          padding: 10px;

          border-right: 1px solid #999;
          background-color: #ddd;

          text-align: left;
          vertical-align: top;

          font-size: 0.75rem;

          a {
            color: #337ab7;
          }
        }

        &.title,
        .table-title {
          td {
            background-color: #ccc;
            color: #626262;
            border-top: 1px solid #999;

            text-align: center;
            font-weight: bold;
            font-size: 12px;

            height: 30px;
            padding-top: 4px;
            padding-left: 5px;

            vertical-align: middle !important;
          }
        }
      }
    }

    .analysis-image {
      text-align: center;
      width: 100%;

      margin-bottom: 20px;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;

        border-radius: 5px;
      }
    }

    .file-list {
      background-color: #fff;
      border-radius: 5px;
      padding: 10px;

      &__item {
        border-radius: 5px;
        background-color: #ccc;

        padding: 5px;

        &:not(:last-child) {
          margin-bottom: 5px;
        }

        .file-title {
          font-weight: bold;
        }

        .file-name {
          font-size: 0.6rem;
        }
      }
    }
  }

  .table-hrn {
    padding: 0 !important;

    tr,
    td {
      padding: 0 !important;
    }
  }

  .table-hrn tr:first-child td {
    border-top: none !important;
  }
  .table-hrn td:first-child {
    border-left: none !important;
  }
  .table-hrn td {
    border: 1px solid #aaa !important;
  }

  .primevue-custom-field {
    height: 30px;
    width: 100%;

    &::v-deep .p-inputtext {
      font-size: 0.75rem;
    }
  }
</style>
